export default "__VITE_ASSET__aYML4W6W__"